import React from 'react';
import ListView from '../discover/ListView';
import './DiscoverListPopup.css';

function DiscoverListPopup({ events = null }) {
  return (
    <div className="discover-list-popup-content discover-list-popup-content--shell">
      <ListView mapVisibleEvents={events} />
    </div>
  );
}

export default DiscoverListPopup;






